import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { toast } from '../components/ui/use-toast';
import { checkAndSetVersionMismatch } from '../lib/versionHelper';

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState({
    accessToken: localStorage.getItem('accessToken'),
    refreshToken: localStorage.getItem('refreshToken'),
    user: JSON.parse(localStorage.getItem('user'))
  });
  const [error, setError] = useState(null);


  const fetchAccessToken = useCallback(async (refreshToken) => {
    try {
      const response = await axios.post('https://skhrf-api.cmdigital.se/v1/auth/token', { refreshToken });
      const decodedToken = jwtDecode(response.data.accessToken);

      setAuth((prevAuth) => ({
        ...prevAuth,
        accessToken: response.data.accessToken,
        user: decodedToken,
      }));

      localStorage.setItem('accessToken', response.data.accessToken);
      localStorage.setItem('user', JSON.stringify(decodedToken));

      checkAndSetVersionMismatch(response.data);

      return response.data.accessToken;
    } catch (error) {
      console.error('Fetching access token failed', error);
      logout();
    }
  }, []);

  // useEffect(async () => {
  //   const storedRefreshToken = localStorage.getItem('refreshToken');
  //   const storedAccessToken = localStorage.getItem('accessToken');
  //   if (storedRefreshToken) {
  //     setAuth((prevAuth) => ({
  //       ...prevAuth,
  //       refreshToken: storedRefreshToken,
  //     }));

  //     if (storedAccessToken) {
  //       setAuth((prevAuth) => ({
  //         ...prevAuth,
  //         accessToken: storedAccessToken,
  //       }));
  //     } else {
  //       await fetchAccessToken(storedRefreshToken);
  //     }
  //   }
  //   setLoading(false); // Stop loading once tokens are retrieved
  // }, []);

  useEffect(() => {
    const initializeAuth = async () => {
      const storedRefreshToken = localStorage.getItem('refreshToken');
      const storedAccessToken = localStorage.getItem('accessToken');

      if (storedRefreshToken) {
        setAuth((prevAuth) => ({
          ...prevAuth,
          refreshToken: storedRefreshToken,
        }));

        if (storedAccessToken) {
          setAuth((prevAuth) => ({
            ...prevAuth,
            accessToken: storedAccessToken,
          }));
        } else {
          await fetchAccessToken(storedRefreshToken);
        }
      }

      setLoading(false); // Stop loading once tokens are retrieved
    };

    initializeAuth(); // Call the async function
  }, [fetchAccessToken]);


  const login = async (email, password) => {
    try {
      const response = await axios.post('https://skhrf-api.cmdigital.se/v1/auth/login', { email, password });
      const refreshToken = response.data.refreshToken;
      setAuth((prevAuth) => ({
        ...prevAuth,
        refreshToken,
      }));
      localStorage.setItem('refreshToken', refreshToken);
      checkAndSetVersionMismatch(response.data);
      await fetchAccessToken(refreshToken);
      setError(null); // Clear any previous errors
      toast({
        variant: 'success',
        title: 'Inloggning lyckad!',
        description: "Välkommen till STAMP.",
      });
    } catch (error) {
      if (error.response && error.response.data && error?.response?.data?.error) {
        setError(error?.response?.data?.error);
        toast({
          variant: 'destructive',
          title: 'Något gick fel.',
          description: error?.response?.data?.error,
        });
      } else {
        setError('Servern är inte tillgänglig. Försök igen senare.');
        toast({
          variant: 'destructive',
          title: 'Något gick fel.',
          description: 'Servern är inte tillgänglig. Försök igen senare.',
        });
      }
    }
  };

  const logout = () => {
    setAuth({ accessToken: null, refreshToken: null, user: null });
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
  };

  const clearError = () => {
    setError(null);
  };

  const isLoggedIn = () => {
    return !!auth.user;
  };

  return (
    <AuthContext.Provider value={{ auth, login, fetchAccessToken, logout, isLoggedIn, error, clearError, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };

